export const DEFAULT_QUIZ_BACKGROUND = 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)';
export const DEFAULT_TEXT_COLOR = '#ffffff';

export const QUIZ_FONT_OPTIONS = [
  { value: 'karla', label: 'Karla', stack: '"Karla", "Helvetica Neue", Arial, sans-serif' },
  { value: 'inter', label: 'Inter', stack: '"Inter", "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' },
  { value: 'source-serif', label: 'Source Serif 4', stack: '"Source Serif 4", Georgia, "Times New Roman", serif' },
  { value: 'space-grotesk', label: 'Space Grotesk', stack: '"Space Grotesk", "Archivo", "Helvetica Neue", sans-serif' },
  { value: 'overpass', label: 'Overpass', stack: '"Overpass", "Fira Sans", "Helvetica Neue", sans-serif' }
];

export const DEFAULT_FONT_KEY = QUIZ_FONT_OPTIONS[0].value;

export const QUIZ_TEXT_SIZE_OPTIONS = ['sm', 'md', 'lg'];
export const QUIZ_TEXT_SIZE_LABELS = {
  sm: 'Sm',
  md: 'Md',
  lg: 'Lg'
};

const TYPOGRAPHY_SCALE = {
  welcome: { sm: 18, md: 24, lg: 32 },
  question: { sm: 16, md: 21, lg: 27 },
  answer: { sm: 14, md: 16, lg: 20 }
};

export const getFontStack = (fontKey) => {
  const fallback = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
  const target = QUIZ_FONT_OPTIONS.find((font) => font.value === fontKey);
  return target?.stack || fallback;
};

export const getTextSizePx = (variant, sizeKey = 'md') => {
  const scale = TYPOGRAPHY_SCALE[variant];
  if (!scale) {
    return 16;
  }
  return scale[sizeKey] || scale.md;
};
